// 預期工時表
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import Calendar from '../../Calendar';

import { 
  getExpectedWorkSheet,
  InitAPIStatus
} from '../../../store/action';

class ExpextWorkTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarConfig: {
        calendarType: "month",
        defaultView: "month",
        draggable: false,
        isEventClick: true,
        isDayClick: true,
        header: {
          left: 'today prev,next',
          center: 'title',
          right: 'month',
        },
      },
      events: []
    }
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleEventClick = this.handleEventClick.bind(this);
    this.handleReRenderMonthEvent = this.handleReRenderMonthEvent.bind(this);
  }

  componentDidMount() {
    this.props.getExpectedWorkSheet();
  }

  componentWillReceiveProps(nextProps) {
    let newEvents = [];
    nextProps.expectdWorkState.forEach(event => {
      let newObj = {
        title: '預期成本: ' + event.expectedCost,
        start: moment(event.start).format('YYYY-MM-DD')
      }
      newEvents.push(newObj);
    });
    this.setState({
      events: newEvents
    });
  }

  handleDayClick(date) {
    this.props.history.push(`/expectedWorkTimeByDay/${date.format('YYYY-MM-DD')}`);
  }

  handleEventClick(event) {
    this.props.history.push(`/expectedWorkTimeByDay/${event.start.format('YYYY-MM-DD')}`);
  }

  handleReRenderMonthEvent(startDate, endDate) {
    this.props.getExpectedWorkSheet(startDate, endDate);
  }

  render() {
    return (
    <div className="u-block">
      <div className="u-title">預期工時表</div>
      <Calendar {...this.state.calendarConfig}
        events={this.state.events}
        dayClick={this.handleDayClick}
        eventClick={this.handleEventClick}

        scheduleReRenderFunc={this.handleReRenderMonthEvent}

      />
    </div>
    )
  }
}


const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  expectdWorkState: store.expectdWorkState,
})

export default connect(mapStateToProps,{
  getExpectedWorkSheet,
  InitAPIStatus
})(withRouter(ExpextWorkTime));